import React from 'react';
import { Link, Image, AspectRatio } from '@chakra-ui/react';

import ImpactReportLayout from '../../../../../components/layouts/impactreport';
import TableOfContents from '../../../../../components/sections/tableofcontents';
import ImpactReporth3 from '../../../../../components/sections/impactreport/impact-h3';
import ImpactReporth4 from '../../../../../components/sections/impactreport/impact-h4';
import ImpactReportPrevNextNav from '../../../../../components/sections/impactreport/prev-next-nav';

import responsiblePracticesHeroImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/responsible-practices/resp_practices_cover_16x9_1.jpg';
import ImpactReporth2 from '../../../../../components/sections/impactreport/impact-h2';

import riseImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/responsible-practices/rise.png'

// Import graphs
import scorecardRatingsImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/responsible-practices/responsible-practices_scorecard-ratings.png';
import assessmentsImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/responsible-practices/responsible-practices_assessments-at-partners.png';

export default function TwentyTwentyFourImpactReportResponsiblePractices() {

    const links = [
        {
            title: "About Us and 2024 Highlights",
            href: "/corporate-responsibility/impact/2024",
            active: false
        },
        {
            title: "Empowering People",
            href: "/corporate-responsibility/impact/2024/empowering-people",
            active: false
        },
        {
            title: "Sustaining Places",
            href: "/corporate-responsibility/impact/2024/sustaining-places",
            active: false
        },
        {
            title: "Responsible Practices",
            //href: "/corporate-responsibility/impact/2024/responsible-practices",
            active: true
        },
        {
            title: "Appendices",
            href: "/corporate-responsibility/impact/2024/appendices",
            active: false
        }
    ];

    const ReportNav = () => {
        return ( 
        <>
            <div>
                <nav id='main-report-nav'>
                    <ul className='nav-list'>
                        {links.map(link => (
                            link.active === false ? (
                            <li key={link.title}>
                                <Link href={link.href} className='nav-link'>
                                    <span className='nav-link__text'>{link.title}</span>
                                </Link>
                            </li>
                            ) :
                            (
                                <li className='active' key={link.title}>
                                    <span className='nav-link__text'>{link.title}</span>
                                    <TableOfContents />
                                </li>
                            )
                        )
                        )}
                    </ul>
                </nav>
            </div>
        </>
        );
      }
    
      function Hero() {
        return(<>
            <section>
                <div className='hero-main height-100'>
                    <div className='hero-main__container'>
                    <div className='hero-main__inner-container'>
                        <div className='hero-main__inner center-left is-top is-left'>
                            <figure className='hero-main__quote'>
                                <div className='hero-main__quote-icon'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="var(--csc-orange)" stroke="currentColor" strokeWidth="0" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-quote-icon lucide-quote"><path d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"/><path d="M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"/></svg>
                                </div>
                                <blockquote className='text-shadow-dark'>
                                    We work to fulfill our mission to connect active people around the world with their passions by creating responsibly made products to help you stay outside longer.
                                </blockquote>
                                <figcaption>
                                    &mdash; Peter Bragdon<br />EVP, Chief Administrative Officer and General Counsel
                                </figcaption>
                            </figure>
                        <div className='hero-main__text container'>
                            <div className="hero-main__content cover-bubble" style={{ backgroundColor: 'var(--csc-orange)' }}>
                                <div>
                                    <h1>Responsible<br />Practices</h1>
                                    <p>By fostering a culture of ethics and compliance and investing in supply chain initiatives, we aim to integrate responsible practices throughout our business.</p>
                                </div>
                            </div>
                        </div>
                        </div>
                        <div className='hero-main__video-container'>
                            <img src={responsiblePracticesHeroImg} alt='' />
                        </div>
                        <div className='hero-main__overlay'></div>
                    </div>
                    </div>
                </div>
            </section>
        </>)
    }
    
    return (
        <ImpactReportLayout
            reportTitle="2024 CSC Impact Report"
            sidebar={<ReportNav />}
            reporthero={<Hero />}
        >
            <title>2024 Impact Report - Responsible Practices</title>
            <meta name="description" content="Highlights Columbia Sportswear Company's commitment to ethical business practices and compliance." />

            <section>
                <div className='container flow'>
                    <ImpactReporth2 style={{ color: 'var(--csc-orange)'}}>Ethics &amp; Compliance</ImpactReporth2>
                    <p>
                        All Columbia Sportswear Company (“CSC”) employees, Board members, and certain partners conducting business on our behalf are responsible for understanding and complying with our <a href='https://d1io3yog0oux5.cloudfront.net/_06b9c61d71a960f03e9ac70564a02500/columbia/db/654/5320/file/Corporate_Code_of_Business-Conduct_and_Ethics_English_.pdf' target='_blank' rel='noreferrer noopener'>Code of Business Conduct and Ethics</a>, along with all related policies. This values-based Code guides our business, meaning that, in addition to complying with the law, we: 
                    </p>
                    <ul>
                        <li>Commit to ethical conduct</li>
                        <li>Encourage and support a speak-up culture</li>
                        <li>Treat one another with dignity and respect</li>
                        <li>Conduct business honestly and compete fairly in the marketplace</li>
                        <li>Protect and properly use company information</li>
                        <li>Engage third-party partners who share our values</li>
                    </ul>
                    <p>
                        Our Ethics and Compliance program is supported by our Corporate Compliance Committee, which champions a culture of ethics, compliance, and alignment with our Code of Business Conduct and Ethics. The committee is composed of senior leaders from Human Resources, Legal, Finance, Internal Audit, and Business teams. With support from the Compliance Committee and the Ethics and Compliance Program, our Audit Committee of the Board oversees the organizational structures, policies, and procedures that promote an ethical, compliant culture at CSC.
                    </p>
                    <p>
                        We provide a confidential compliance phone line and a web-based reporting platform for employees and other stakeholders to report concerns. Both channels follow CSC’s confidentiality protocols and allow anonymous reporting where permitted by local law. All reports submitted through these channels related to compliance are shared with the Chair of the Audit Committee.
                    </p>
                    <p>
                        Each July, we recognize Ethics & Compliance Month with an internal employee campaign centered around our value of “Doing the Right Thing.” In 2024, the campaign highlighted the Compliance Line and promoted a culture of speaking up. 
                    </p>
                </div>
            </section>
            <section>
                <div className='container flow'>
                    <ImpactReporth2 style={{ color: 'var(--csc-orange)'}}>Traceability</ImpactReporth2>
                    <p>
                        CSC has long been committed to transparency and traceability. Since 2013, we have updated our <a href='/corporate-responsibility-group/responsible-practices/supply-chain' target='_blank' rel='noreferrer noopener'>Supply Chain Transparency Map</a> semiannually, publicly sharing information about our Tier 1 and Tier 2 manufacturing partners. This interactive map allows users to trace the global production locations of our apparel, footwear, and other products.
                    </p>
                    <p>
                        In addition to our live Supply Chain Transparency Map, we continue to invest in proven strategies to reduce upstream supply chain risks and disruptions. This includes adopting new technology platforms that enable our supply chain partners to provide key information about the upstream facilities and processes involved in creating our products. We have also implemented risk-based testing to verify material origins and standardized our chain of custody documentation collection and validation processes. These initiatives enhance the granularity, completeness, and accuracy of our supply chain maps.
                    </p>
                </div>
            </section>
            <section>
                <div className='container flow'>
                    <ImpactReporth2 style={{ color: 'var(--csc-orange)'}}>Social Responsibility In Our Supply Chain</ImpactReporth2>
                    <div className='rise flow' style={{ marginTop: 'var(--space-l)' }}>
                        <ImpactReporth3>RISE</ImpactReporth3>
                        <Image 
                            src={riseImg}
                            float={'right'}
                            width={{ base: '100%', sm: '50%' }}
                            marginLeft={'var(--space-m)'}
                            marginBottom={'var(--space-l)'}
                            alt='RISE' 
                            rel='noreferrer noopener' 
                            className='rise-img'
                            borderRadius={'50%'} 
                        />
                        <p>
                            CSC’s partnership with RISE (Reimagining Industry to Support Equality) has had a positive impact on thousands of workers, predominantly women-identifying, in the global garment, footwear, and home textiles supply chains. With RISE’s focus on collaborative industry action to improve equality and create resilient futures, CSC has helped fund 49 RISE workplace programs across six countries. Since 2008, over 106,000 workers have benefitted from the education and resources provided through our ongoing partnership, with over 84,000 participants identifying as women. RISE programs focus on financial health, preventing and remediating violence and harassment in the workplace, skills development, and digital literacy and access. RISE’s core strategies include strengthening program capacity, fostering collaborative market transformation, and influencing public policy. In 2024, RISE, along with its industry supporters, reached over 425 workplaces, impacting over 375,000 workers, over 65% of whom identify as women. To learn more about RISE programs, visit the <a href="https://riseequal.org/" target='_blank' rel='noreferrer noopener'>RISE website</a>, <a href="https://www.linkedin.com/company/reimaginingindustrytosupportequality/posts/?feedView=all" target='_blank' rel='noreferrer noopener'>LinkedIn account</a> and <a href="https://www.youtube.com/@RISE_Equal" target='_blank' rel='noreferrer noopener'>YouTube Channel</a>.
                        </p>
                        <AspectRatio ratio={16 / 9}>
                            <iframe 
                                src="https://www.youtube.com/embed/iqbYa6uhqSw?si=3x0ftYEG2yRaTmzk" 
                                title="YouTube video player" 
                                frameborder="0" 
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                                referrerpolicy="strict-origin-when-cross-origin" 
                                allowfullscreen
                            />
                        </AspectRatio>
                        
                    </div>
                </div>
                <div className='container flow' style={{ marginTop: 'var(--space-xl)' }}>
                    <ImpactReporth3>Manufacturing Scorecard Program</ImpactReporth3>
                    <p>
                        Our CSC Supplier Code of Conduct, also known as our Standards of Manufacturing Practices (“SMP”), outlines the requirements for the production of apparel, footwear, equipment, and accessories. The SMP aligns with the standards set by the International Labour Organization (“ILO”), the Fair Labor Association (“FLA”), and industry best practices, and includes strict prohibitions on forced labor throughout our supply chain.
                    </p>
                    <p>
                        In 2024, we worked directly with 330 finished good vendors, 87% of whom completed at least one audit or assessment during the year. To evaluate Tier 1 vendor compliance with our SMP and local labor laws, we use a variety of methods, including:
                    </p>
                    <ul>
                        <li>Assessments conducted by the ILO Better Work program</li>
                        <li>Verified assessments using the Social and Labor Convergence Program’s (“SLCP”) Converged Assessment Framework</li>
                        <li>Unannounced audits by our internal specialists or designated third-party firms</li>
                        <li>Audits aligned with other recognized standards</li>
                    </ul>
                    <p>
                        We use the results of these audits and assessments to generate performance scorecards, which are updated monthly. When issues are identified, corrective action plans are promptly implemented to address and prevent recurrence.
                    </p>
                    <figure className='table-img'>
                        <figcaption>
                            <p>2018-2024 CSC Tier 1 Manufacturing Partner Social Responsibility Scorecard Ratings (Percent)</p>
                        </figcaption>
                        <Image src={scorecardRatingsImg} alt='Scorecard Ratings' className='scorecard-ratings-img' />
                    </figure>
                    
                </div>
                <div className='container flow'>
                    <ImpactReporth3>Audits &amp; Assessments</ImpactReporth3>
                    <p>
                        Ensuring safe and proper working conditions across our supply chain is a core expectation of business partners. We support these partners with a dedicated, international team of in-house experts who provide on-site guidance and assessments for continuous improvement. Our social responsibility program focuses on ensuring that our supply chain operates in accordance with our Standards of Manufacturing Practices (“SMP”) and our Code of Business Conduct and Ethics. We remain committed to supporting our supply chain partners through resource capacity building, worker empowerment programs, and corrective remediation plans.
                    </p>
                    <ImpactReporth4>Better Work Program</ImpactReporth4>
                    <p>
                        The United Nations’ International Labour Organization (“ILO”) and the International Finance Corporation (“IFC”), a member of the World Bank Group, partner to support the apparel sector through the Better Work program. This collaborative initiative brings together the apparel and textile industry to improve working conditions, uphold workers’ labor rights, and enhance the global industry’s competitiveness. CSC actively engages with and encourages our supplier partners to join the Better Work program, reinforcing labor standards and national legislative policies. Contributing to the improvement of workers’ compensation and labor conditions is a key aspect of CSC’s core value of “doing the right thing.” In 2024, 81 of our finished goods manufacturing partner facilities were registered with the Better Work program.
                    </p>
                    <ImpactReporth4>Social Labor &amp; Convergence Program</ImpactReporth4>
                    <p>
                        Launched in 2015, the Social & Labor Convergence Program (“SLCP”) was developed through collaboration within the apparel and footwear industry. The program’s primary focus is to monitor and improve working conditions across global supply chains by standardizing manufacturing audits through the Converged Assessment Framework (“CAF”). CAF delivers reliable audit data that allows brands to track and engage product vendors efficiently to foster continuous improvement in working conditions. Given the highly collaborative nature of the apparel and footwear industry, these standardized assessments allow industry stakeholders sourcing from the same suppliers to collectively support vendors in improving workplace conditions. SLCP streamlines data collection, verification, and sharing, helping brands enhance their social responsibility programs. In 2024, 215 manufacturing partners (Tier 1 and Tier 2) completed the SLCP self-assessment and verification process. These assessments contribute to our vendor scorecards and guide ongoing improvement efforts.
                    </p>
                    <figure className='table-img'>
                        <figcaption>
                            <p>Number of Industry Assessments Performed at our Manufacturing Partners’ Facilities</p>
                        </figcaption>
                        <Image src={assessmentsImg} alt='Assessments' className='assessments-img' />
                    </figure>
                    
                </div>
            </section>

            <ImpactReportPrevNextNav
                prevText="Sustaining Places"
                prevLink="/corporate-responsibility/impact/2024/sustaining-places"
                nextText="Appendices"
                nextLink="/corporate-responsibility/impact/2024/appendices"
            />
            
            
        </ImpactReportLayout>

        
    );
}
